<template>
  <div class="yssm">
    <div class="docs-header">隐私声明</div>
    <div class="container">
      <div class="content">弈小象承诺将按照本隐私声明收集、使用和披露用户信息，除本声明另有规定外，</div>
      <div class="content">不会在未经用户许可的情况下向第三方或公众披露用户信息：</div>
      <div class="content">1、用户信息的范围包括：用户注册的账户信息、用户上传的信息、弈小象自动接收的用户信息、弈小象通过合法方式收集的用户信息等。</div>
      <div class="content">2、用户信息的收集、使用和披露</div>
      <div class="content">只在如下情况下，弈小象会合法披露用户信息：
        <div class="content">（1）经用户事先同意，向第三方披露。</div>
        <div class="content">（2）根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露。</div>
        <div class="content">（3）其他根据法律、法规或者政策应进行的披露。</div>
      </div>
      <div class="content">3、用户信息的保护
        <div class="content">（1）用户的账户均有安全保护功能，请妥善保管账户及密码信息。弈小象将通过服务器数据备份，确认技术上以实现安全的对用户密码进行加密等措施尽可能确保用户信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请用户注意因囿于现有技术在信息网络上并不存在“绝对的安全措施”。 对黑客等蓄意非法侵入并窃取信息的行为弈小象不承担责任。因此请用户在设置此密码时，切勿使用与其银行卡、存折、网银、手机钱包、电子邮件地址、QQ、WI-FI等一切需要保密之账户相同或近似的密码。</div>
        <div class="content">（2）除非经过用户同意，弈小象不允许任何用户、第三方通过弈小象收集、出售或者无偿传播用户信息。</div>
        <div class="content">（3）弈小象含有到其他网站的链接，弈小象不对那些网站的隐私保护措施负责。当用户登录那些网站时，请提高警惕，保护个人隐私。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yssm'
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .yssm {
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px) {
      width: 1180px;
    }
  }
  .docs-header{
    font-family:microsoft yahei;
    font-size: 36px;
    font-weight: bold;
    position: relative;
    padding: 60px 0;
    text-align: center;
    text-shadow: 0 1px 0 rgba(0,0,0,.1);
    background-color: #f2f9fe;
    border-bottom: 1px solid #e9f0f3;
  }
  .continer{
    box-sizing: border-box;
    width: 100%;
    padding: 20px;
  }
  .content{
    width: 100%;
    font-family:microsoft yahei;
    font-size: 18px;
    line-height: 60px;
    letter-spacing: 5px;
  }
  .title{
    width: 100%;
    font-family:microsoft yahei;
    font-size: 36px;
    font-weight: bold;
    margin: 30px 0;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/yssm.vue